/* eslint-disable max-lines */
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import summaryService from './summaryService'
import { State } from './types'
import json from './defaultData.json'

export const summaryMapLayers = [
  'land',
  'authorizedLimit',
  'restrictions',
  'buildings',
]

const initialState: State = {
  loading: false,
  error: false,
  loadEstimation: false,
  regionsByName: {},
  informations: json,
  selectedLayers: summaryMapLayers,
  cityGeoCenter: {},
  cityGeojson: {},
  estimatedEdited: {},
  user: {},
  company: {},
  estimatedId: null,
  theme: null,
  transactionDetail: {},
  office: {},
}

export const getDealInformations = createAsyncThunk(
  'summary/getDealInformations',
  summaryService.getDealInformations,
)

export const getPublicEditedEstimate = createAsyncThunk(
  'estimateLandSummary/getPublicEditedEstimate',
  summaryService.getPublicEditedEstimate,
)

export const downloadFile = createAsyncThunk(
  'summary/downloadFile',
  summaryService.downloadFile,
)

const estimateSummary = createSlice({
  name: 'estimateSummary',
  initialState,
  reducers: {
    updateTheme(state, action) {
      if (action.payload.primary || action.payload.secondary) {
        state.theme = {
          primary: action.payload.primary ? `#${action.payload.primary}` : null,
          secondary: action.payload.secondary
            ? `#${action.payload.secondary}`
            : null,
          fontFamily: action.payload.fontFamily,
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDealInformations.pending, (state) => {
        state.loading = true
      })
      .addCase(getDealInformations.fulfilled, (state, action) => {
        const { data } = action.payload || {}

        if (!data) return

        state.loading = false
        state.error = false
        state.informations = data
        state.office = data?.office
      })
      .addCase(getDealInformations.rejected, (state) => {
        state.loading = false
        state.error = true
        state.informations = {}
        window.location.href = '/link-expired'
      })
      .addCase(getPublicEditedEstimate.fulfilled, (state, action) => {
        const { data } = action.payload || {}

        state.estimatedEdited = data
      })
  },
})

export const estimateSummaryReducer = {
  estimateSummary: estimateSummary.reducer,
}

export const { updateTheme } = estimateSummary.actions
